import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="border-t-4 border-signal bg-navy text-center" data-id="element-87" data-mp="eiv62y7sfcld">
      <div className="px-3 pb-4 pt-3 sm:px-6 sm:pb-5 sm:pt-4" data-id="element-88" data-mp="9kjvgl9o4y23">
        <h1 className="font-display text-[0.74rem] font-extrabold uppercase leading-tight text-white/90 sm:text-[0.95rem]" data-id="element-89" data-mp="9ipbpaa4vbzl">
          THE COMPLETE <span className="text-signal" data-id="element-90" data-mp="12a0lxddqa4vo">FIBER OPTIC FAULT-FINDING &amp; TROUBLESHOOTING</span> SYSTEM
        </h1>
        <p className="mt-1 font-display text-[1.45rem] font-extrabold uppercase leading-[1.05] text-white sm:text-[2.25rem]" data-id="element-91" data-mp="xa4ipgcuuhh6">
          STOP GUESSING THE FAULT. <span className="text-signal" data-id="element-92" data-mp="sddzik5r75rj">START DIAGNOSING WITH PRECISION.</span>
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-93" data-mp="nbydaoruat7k">
          Interpret complex OTDR traces, locate fiber optic faults, investigate signal loss, troubleshoot FTTH and
          PON networks, analyze defective connections, and verify repairs—all in one complete professional
          diagnostic system.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[290px] sm:max-w-[380px]" data-id="element-94" data-mp="3o6aq9wsnq90h" />

        <div className="mx-auto mt-2 max-w-md" data-id="element-95" data-mp="39b4hj226fw3g">
          <CTAButton label="🚀 YES! I WANT MY FIBER OPTIC DIAGNOSTIC SYSTEM NOW" data-id="element-96" data-mp="39cflp2zjb5v3" />
          <p className="mt-2 text-[0.68rem] font-bold uppercase tracking-wide text-gold sm:text-xs" data-id="element-97" data-mp="3e7uxzqhw8tpe">
            🛡️ 7-Day Money-Back Guarantee — Zero Risk
          </p>
        </div>
      </div>
    </header>;
}